/**
 * Loading placeholders shaped like the content that is coming, never a full-page spinner: the
 * layout must not jump when data lands.
 */
export function Skeleton({ className = "" }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`block rounded-control bg-surface-2 ${className}`.trim()}
      style={{
        backgroundImage:
          "linear-gradient(90deg, transparent 0%, color-mix(in srgb, var(--surface-1) 70%, transparent) 50%, transparent 100%)",
        backgroundSize: "200% 100%",
        animation: "nb-shimmer 1.2s linear infinite",
      }}
    />
  );
}

/** A few stacked lines, the shape most of our loading content takes. */
export function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="grid gap-s3" role="status" aria-label="Innehåll laddas">
      {Array.from({ length: lines }, (_, index) => (
        // The last line is short, the way a real paragraph ends.
        <Skeleton key={index} className={index === lines - 1 ? "h-s5 w-1/2" : "h-s5 w-full"} />
      ))}
    </div>
  );
}
